import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { useT, useUI, useLang } from "../lib/i18n";
import SEO from "../components/site/SEO";

export default function Services() {
  const { content } = useOutletContext();
  const t = useT();
  const ui = useUI();
  const lang = useLang();
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then(({ data }) => setServices(data)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const intro = content.services_intro || {};
  const seo = (content.seo || {}).services;

  return (
    <div data-testid="services-page">
      <SEO seoData={seo} />
      <section className="max-w-7xl mx-auto px-6 md:px-12 pt-16 pb-12">
        <p className="overline mb-4">{t(intro.overline) || ui.servicesLabel}</p>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tighter leading-none font-light max-w-3xl">{t(intro.title)}</h1>
        <p className="mt-8 max-w-2xl text-[#4A3F35] text-lg">{t(intro.description)}</p>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-12 pb-24 space-y-24">
        {services.map((s, i) => (
          <motion.div key={s.id} initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.9 }} className={`grid md:grid-cols-2 gap-12 items-center ${i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""}`} data-testid={`service-detail-${i}`}>
            <div className="rounded-3xl overflow-hidden aspect-[4/5]"><img src={s.image_url} alt={t(s.title)} className="w-full h-full object-cover" /></div>
            <div>
              <span className="font-serif text-3xl text-[#C87A5E]">{s.number}</span>
              <h2 className="font-serif text-4xl md:text-5xl mt-2 tracking-tight">{t(s.title)}</h2>
              <p className="mt-6 text-[#4A3F35] leading-relaxed">{t(s.short_description)}</p>
              {t(s.full_description) && (<p className="mt-4 text-[#4A3F35] leading-relaxed whitespace-pre-line">{t(s.full_description)}</p>)}
              <Link to={`/${lang}/contact`} className="btn-primary mt-8">{ui.bookSession} <ArrowRight size={16} /></Link>
            </div>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
